class MobileMenuDrawer extends HTMLElement {
  connectedCallback() {
    // The header markup renders this element inside the sticky header
    // section wrapper (.section-header, position: sticky; z-index: 3 in
    // Dawn's base.css), which traps this drawer's own z-index: 100 inside
    // that ancestor's local stacking context -- the topbar section next
    // to it then paints on top of the drawer instead of the reverse.
    // Move it to a direct child of <body> so its z-index competes at the
    // document root instead.
    if (this.parentElement !== document.body) {
      document.body.appendChild(this);
    }

    this.closeTargets = this.querySelectorAll('[data-mobile-menu-close]');
    this.triggers = document.querySelectorAll('[data-mobile-menu-toggle]');

    this.triggers.forEach((trigger) => {
      trigger.addEventListener('click', () => this.open());
    });

    this.closeTargets.forEach((target) => {
      target.addEventListener('click', () => this.close());
    });

    this.querySelectorAll('[data-mobile-submenu-open]').forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const id = trigger.getAttribute('data-mobile-submenu-open');
        const panel = this.querySelector(`[data-mobile-menu-level="${id}"]`);
        if (panel) panel.classList.add('is-active');
      });
    });

    this.querySelectorAll('[data-mobile-submenu-back]').forEach((backButton) => {
      backButton.addEventListener('click', () => {
        backButton.closest('.mobile-menu-drawer__level--submenu').classList.remove('is-active');
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') this.close();
    });
  }

  open() {
    this.classList.add('is-open');
    document.body.classList.add('mobile-menu-drawer-open');
    this.triggers.forEach((trigger) => trigger.setAttribute('aria-expanded', 'true'));
  }

  close() {
    this.classList.remove('is-open');
    document.body.classList.remove('mobile-menu-drawer-open');
    this.triggers.forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
    // Reset to the root list so reopening the drawer later doesn't land
    // back on whatever submenu happened to be open last time.
    this.querySelectorAll('.mobile-menu-drawer__level--submenu.is-active').forEach((panel) => {
      panel.classList.remove('is-active');
    });
  }
}

if (!customElements.get('mobile-menu-drawer')) customElements.define('mobile-menu-drawer', MobileMenuDrawer);
